// Dependencies
import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';
// Types
import { User } from '../../user/objects/user';
import { ExtractionState } from '../objects/extractionState';
import { ProviderActivation } from '../../provider/objects/providerActivation';
import { DestinationReduced } from '../../destination/objects/destinationReduced';

const initialState: ExtractionState = {
  confirmation_end_date: null,
  confirmation_start_date: null,
  destination: [],
  edit_step: null,
  end_date: null,
  provider: [],
  seller: [],
  start_date: null,
};

export const extractionSlice = createSlice({
  name: 'extraction',
  initialState,
  reducers: {
    setEditStep: (state, action: PayloadAction<null | 'MARGIN' | 'PROVISION' | 'COLLECTION' | 'INVOICE' | 'CREDIT_NOTE' | 'INSURANCE'>) => {
      state.edit_step = action.payload;
    },
    updateConfirmationEndDate: (state, action: PayloadAction<null | Date>) => {
      state.confirmation_end_date = action.payload;
    },
    updateConfirmationStartDate: (state, action: PayloadAction<null | Date>) => {
      state.confirmation_start_date = action.payload;
    },
    updateDestination: (state, action: PayloadAction<DestinationReduced[]>) => {
      state.destination = action.payload;
    },
    updateEndDate: (state, action: PayloadAction<null | Date>) => {
      state.end_date = action.payload;
    },
    updateProvider: (state, action: PayloadAction<ProviderActivation[]>) => {
      state.provider = action.payload;
    },
    updateSeller: (state, action: PayloadAction<User[]>) => {
      state.seller = action.payload;
    },
    updateStartDate: (state, action: PayloadAction<null | Date>) => {
      state.start_date = action.payload;
    },
  },
});

export const {
  setEditStep,
  updateConfirmationEndDate,
  updateConfirmationStartDate,
  updateDestination,
  updateEndDate,
  updateProvider,
  updateSeller,
  updateStartDate,
} = extractionSlice.actions;

export default extractionSlice.reducer;